/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {ReactComponent as DeleteIcon} from "../../../styles/icon/delete.svg";
import styles from './WebhookCertificateItem.module.scss';
import Tooltip from "../../../elements/Tooltip/Tooltip";

const WebhookCertificateItem = (props) => {
    const {
        fileName,
        onClick,
        onRevoke,
        validDate,
        expDate
    } = props;
    return (
        <div className={styles.certificate_item}>
            <div className={styles.certificate_row}>
                <div className={styles.certificate_label}>
                    <a style={{cursor: 'pointer', color: 'grey'}} onClick={onClick}>
                        <Tooltip content={fileName}>
                            <span>
                                {fileName}
                            </span>
                        </Tooltip>
                    </a>
                </div>
                <div className={styles.certificate_value}>{validDate}</div>
                <div className={styles.certificate_value}>{expDate}</div>
                <DeleteIcon style={{cursor: 'pointer'}} onClick={onRevoke}/>
            </div>
        </div>
    );
};

export default WebhookCertificateItem;
